/**
 * IDENTAR LA PLANTILLA Y EL LECTOR (Mario, 09-oct noche: «con opción de identar, para que se vean bien y no regados»).
 * Solo cambia cómo se ve: el generador del núcleo borra todos los espacios y saltos, así que el archivo es el mismo.
 *   · plantilla: un campo por línea; los bloques que se repiten (<template iterable>, <div>, <tr>…) con sangría.
 *   · lector: JSON con dos espacios.
 */
const CONTENEDORES = ['template', 'div', 'tr', 'tbody', 'tfooter', 'container'];
const nombreDe = (tag: string): string => (tag.match(/^<\/?\s*([a-zA-Z0-9]+)/) || [])[1]?.toLowerCase() || '';

export function identarPlantilla(texto: string): string {
  const limpio = String(texto || '').replace(/>\s+</g, '><').replace(/\r?\n|\r/g, '').trim();
  const tokens = limpio.match(/<[^>]+>|[^<]+/g) || [];
  const lineas: string[] = [];
  let actual = '';
  let nivel = 0;
  let enLinea = 0;   // etiquetas no contenedoras abiertas (pad, custom, truncate…): su contenido va en la misma línea
  const cerrar = (): void => { if (actual.trim()) lineas.push('  '.repeat(nivel) + actual.trim()); actual = ''; };
  for (const t of tokens) {
    const esTag = t.startsWith('<');
    const nombre = esTag ? nombreDe(t) : '';
    const cierra = esTag && /^<\//.test(t);
    if (esTag && CONTENEDORES.includes(nombre) && enLinea === 0) {
      cerrar();
      if (cierra) { nivel = Math.max(0, nivel - 1); lineas.push('  '.repeat(nivel) + t); } else { lineas.push('  '.repeat(nivel) + t); nivel++; }
      continue;
    }
    if (esTag && nombre === 'br' && enLinea === 0) { cerrar(); lineas.push('  '.repeat(nivel) + t); continue; }
    if (esTag && !cierra && enLinea === 0) cerrar();
    actual += t;
    if (esTag && !/\/>$/.test(t)) enLinea += cierra ? -1 : 1;
    if (enLinea < 0) enLinea = 0;
    if (esTag && cierra && enLinea === 0) cerrar();
  }
  cerrar();
  return lineas.join('\n');
}

export function identarJson(texto: string): string {
  try { return JSON.stringify(JSON.parse(String(texto || '')), null, 2); } catch (e) { throw new Error('No es un JSON válido: revisa comas, llaves y comillas.'); }
}
